import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import pinia from './stores'
// import { ElMessage } from 'element-plus'
import DataVVue3 from '@kjgl77/datav-vue3'

import ElementPlus from 'element-plus'
import BaseSvg from '@/components/BaseSvg.vue' // svg组件
import * as ElIconModules from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import Information from '@/components/personalCenter/information.vue'
import AuthPage from '@/components/personalCenter/authPage.vue'

import "./assets/less/index.less"

const app = createApp(App)
const appComponents = {
  // 动态组件不能使用大写命名？
  'information': Information,
  'authPage': AuthPage,
}
for(let name in appComponents){
  app.component(name, appComponents[name])
}

// app.use(ElementPlus)

// 统一注册el-icon图标
for(let iconName in ElIconModules){
  app.component(iconName,ElIconModules[iconName])
}
app.component('svg-icon', BaseSvg)
import '@/icons/index.js'


app.directive('permission', (el, binding) => {
  const power = binding.value;
  if (typeof binding.value === 'undefined') return;
  let userInfo = JSON.parse(localStorage.getItem('userInfo'))
  let userPermission = userInfo?.role?.permissions.map((item) => item.name)
  if (!(userPermission?.includes(power))) {
    el.style.display = 'none'
  }
})
app.use(ElementPlus)
app.use(DataVVue3)
app.use(router)
app.use(pinia)
app.mount('#app')
